<template>
  <modal
      id="tenant-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Tenant')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <!--        v-if="selectedUrl"-->
    <form
        ref="form"
        :data-url='selectedUrl ? selectedUrl : TENANT_CREATE'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-6">
          <app-form-group
              :label="$t('name')"
              :placeholder="$placeholder('name')"
              v-model="formData.name"
              :required="true"
              :error-message="$errorMessage(errors, 'name')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              :label="$t('short_name')"
              :placeholder="$placeholder('short_name')"
              v-model="formData.short_name"
              :required="true"
              :error-message="$errorMessage(errors, 'short_name')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-form-group
              :label="$t('legal_name')"
              :placeholder="$placeholder('legal_name')"
              v-model="formData.legal_name"
              :required="true"
              :error-message="$errorMessage(errors, 'legal_name')"
          />
        </div>
        <div
            v-if="!selectedUrl"
            class="col-md-6">
          <app-form-group
              type="email"
              :label="$t('email')"
              :placeholder="$placeholder('email')"
              v-model="formData.email"
              :required="false"
              :error-message="$errorMessage(errors, 'email')"
          />
        </div>
<!--      </div>-->

<!--      <div class="row">-->
        <div
            v-if="!selectedUrl"
            class="col-md-6">
          <app-form-group
              type="text"
              :label="$t('phone')"
              :placeholder="$placeholder('phone')"
              v-model="formData.phone"
              :required="false"
              :error-message="$errorMessage(errors, 'phone')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="url"
              :label="$t('external_url')"
              :placeholder="$placeholder('external_url')"
              v-model="formData.external_url"
              :required="false"
              :error-message="$errorMessage(errors, 'external_url')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="textarea"
              :label="$t('description')"
              :placeholder="$placeholder('description')"
              v-model="formData.description"
              :required="false"
              :error-message="$errorMessage(errors, 'description')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-form-group
              type="select"
              :label="$t('industry_type')"
              list-value-field="name"
              v-model="formData.industry_type"
              :chooseLabel="$t('industry_type')"
              :list="industries"
              :placeholder="$placeholder('industry')"
              :error-message="$errorMessage(errors, 'industry_type')"
              :required="true"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="select"
              :label="$t('company_size')"
              list-value-field="name"
              v-model="formData.company_size"
              :chooseLabel="$t('company_size')"
              :list="companySizes"
              :placeholder="$placeholder('company_size')"
              :error-message="$errorMessage(errors, 'company_size')"
              :required="true"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <app-form-group
              type="switch"
              :label="$t('enable_trial')"
              :placeholder="$placeholder('enable_trial')"
              v-model="formData.enable_trial"
              :required="false"
              :error-message="$errorMessage(errors, 'trial_ends_at')"
          />
        </div>
        <div class="col-md-3">
          <app-form-group
              type="switch"
              :label="$t('active')"
              :placeholder="$placeholder('active')"
              v-model="formData.active"
              :required="false"
              :error-message="$errorMessage(errors, 'active')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="select"
              :label="$t('package')"
              :placeholder="$placeholder('package')"
              v-model="formData.subscription_package"
              :list="subscriptionPackages"
              :required="true"
              :error-message="$errorMessage(errors, 'subscription_package')"
          />
        </div>
      </div>


      <fieldset
          v-if="!selectedUrl"
      >
        <legend>{{ $t('owners_details') }}</legend>
        <div class="row">
          <div class="col-md-6">
            <app-form-group
                type="text"
                :label="$t('first_name')"
                :placeholder="$placeholder('first_name')"
                v-model="formData.first_name"
                :required="true"
                :error-message="$errorMessage(errors, 'first_name')"
            />
          </div>
          <div class="col-md-6">
            <app-form-group
                type="text"
                :label="$t('last_name')"
                :placeholder="$placeholder('last_name')"
                v-model="formData.last_name"
                :required="true"
                :error-message="$errorMessage(errors, 'last_name')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-form-group
                type="text"
                :label="$t('password')"
                :placeholder="$placeholder('password')"
                v-model="formData.password"
                :required="true"
                :error-message="$errorMessage(errors, 'password')"
            />
          </div>
        </div>
      </fieldset>


    </form>
  </modal>
</template>

<script>
// import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  TENANTS_FRONT_END,
  TENANT_CREATE,
  SELECTABLE_PACKAGES,
} from "../../../Config/ApiUrl";
import {addChooseInSelectArray} from "../../../../common/Helper/Support/FormHelper";
import countries from "../Employee/Helper/countries";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";

export default {
  name: "TenantCreateEditModel",
  mixins: [FormHelperMixins, ModalMixin],
  props: {
    from: {
      type: String,
      default: 'tenant'
    },
    companySize: {
      type: Array,
      default: []
    },
    industry: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      isMailSettingExist: true,
      formData: {
        tenant_id: '',
        name: '',
        short_name: '',
        legal_name: '',
        industry_type: '',
        company_size: '',
        email: '',
        phone: '',
        description: '',
        external_url: '',
        enable_trial: '',
        active: '',
        first_name: '',
        last_name: '',
        subscription_package: '',
        // is_in_employee: false,
      },
      TENANTS_FRONT_END,
      TENANT_CREATE,
    }
  },
  methods: {
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#tenant-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'tenant' ? 'tenant-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      //Before customization this was "  this.formData = data;"
      this.formData = {...this.formData, ...data};

      this.formData.enable_trial = data.subscription.trial_ends_at;
      let trialEndsAt = new Date(data.subscription.trial_ends_at);
      let currentDate = new Date();

      // Check if the trial end date is in the future
      this.formData.enable_trial = trialEndsAt > currentDate;
      this.formData.subscription_package = data.subscription_package?.id;

      // this.formData.department_id = data.department?.id;
      // this.formData.employment_status_id = data.employment_status?.id;
      // this.formData.dont_show_in_employee = parseInt(this.formData.is_in_employee) ? 0 : 1;
      // this.formData.joining_date = data.profile?.joining_date ? new Date(data.profile?.joining_date) : null;
      // this.formData.gender = data.profile?.gender;
      // this.formData.nationality = data.profile.nationality;
      // this.formData.contract_start_date = data.profile.contract_start_date;
      // this.formData.contract_end_date = data.profile.contract_end_date;
    },
    // checkMailSettings() {
    //   this.preloader = true;
    //   axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
    //     this.isMailSettingExist = !!response.data;
    //   }).finally(() => {
    //     this.preloader = false;
    //   });
    // },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
    this.$store.dispatch('getSelectablePackages')
  },
  computed: {
    subscriptionPackages() {
      return addChooseInSelectArray(this.$store.state.packages.selectable, 'value', this.$t('package'))
    },
    industries() {
      return addChooseInSelectArray(this.industry, 'name', this.$t('industry'))
    },
    companySizes() {
      return addChooseInSelectArray(this.companySize, 'name', this.$t('company_size'))
    },
  },
}
</script>